import { h, render, Fragment } from 'preact';
import { useRef, useEffect, useState, useMemo } from 'preact/hooks';
import IconCart from '../utils/icon/cart.svg';
import IconHamburgerClosed from '../utils/icon/hamburger-closed.svg';
import SearchForm from './search-form';
import MainMenu from './main-menu';
import Image from '../utils/image';
import { useWindowSize } from '../utils/window-size';
import PromoBar from './promo-bar';
import MobileMenu from './mobile-menu';
import Backdrop from '../utils/backdrop';

const Header = ({ data }) => {
  const { width } = useWindowSize();
  const promoBarRef = useRef(null);
  const headerContainer = document.querySelector('.site-header');
  const mobileOpenTrigger = useRef(null);
  const [showBackDrop, setShowBackDrop] = useState(false);
  const cartOpenEvent = new CustomEvent('cart:open');
  const [menuTriggers, setMenuTriggers] = useState({
    openTriggerEl: null,
    closeTriggerEl: null,
  });

  useEffect(() => {
    try {
      headerContainer.style.top = `-${promoBarRef?.current?.clientHeight}px`;
      headerContainer.style.zIndex = '20';
    } catch (e) {
      // no header container on page yet
    }
  }, [width, promoBarRef?.current?.clientHeight]);

  useEffect(() => {
    setMenuTriggers({
      openTriggerEl: mobileOpenTrigger.current,
    });
  }, [mobileOpenTrigger]);

  const promoBarMemo = useMemo(
    () => <PromoBar data={data} promoBarRef={promoBarRef} />,
    [data],
  );

  return (
    <>
      <div className="z-[41] relative">
        {promoBarMemo}
        <div className="w-full bg-neutral relative laptop:border-b border-black-30 pt-4 pb-[15px] laptop:py-0">
          <div className="flex justify-between container laptop:px-10 flex-wrap laptop:flex-nowrap">
            <a
              href={window.Shopify.routes.root}
              className="link-unstyled min-w-[86px] logo w-[86px] relative ml-5 laptop:ml-0 flex items-center"
            >
              <Image src={data.logo} />
            </a>
            <div className="hidden laptop:block mr-auto w-full laptop:pt-0 pt-[26px]">
              <MainMenu
                menu={data.menus[0].desktop_menu}
                className="pt-[26px]"
                setShowBackDrop={setShowBackDrop}
              />
            </div>
            <div className={'flex items-center pr-5 laptop:pr-0'}>
              <div className={'mr-4 laptop:mr-[27px] flex items-center'}>
                <SearchForm search_form={data.search_form} />
              </div>
              <button
                type="button"
                className="relative h-[24px] w-[20px]"
                onClick={() => document.dispatchEvent(cartOpenEvent)}
              >
                <IconCart />
                <span
                  className="absolute top-[9.5px] laptop:top-[9px] font-base text-[10px] w-full inset-x-0 text-center text-[#242424]"
                  data-cart-count
                ></span>
              </button>
              <button className="ml-4 laptop:hidden" ref={mobileOpenTrigger}>
                <IconHamburgerClosed />
              </button>
            </div>
          </div>
        </div>
      </div>
      <Backdrop isOpen={showBackDrop} setIsOpen={setShowBackDrop} />
      <MobileMenu
        logo={data.logo}
        menu={data.menus[0].desktop_menu}
        menuTriggers={menuTriggers}
        customer={data.customer}
        locatorUrl={data.locatorUrl}
      />
    </>
  );
};

export default (element, data) => {
  const init = () => {
    render(<Header className="header-component" data={data} />, element);
  };

  init();

};
